var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:1.82px;}")), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.09,
    y1: 11.09,
    x2: 22.91,
    y2: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.73,22H6.27a1.82,1.82,0,0,1-1.8-1.52L2.91,11.09H21.09l-1.56,9.39A1.82,1.82,0,0,1,17.73,22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12 16.55 7.46 11.09 16.55 11.09 12 16.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.64,
    y1: 18.36,
    x2: 20.18,
    y2: 18.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.55,
    y1: 14.73,
    x2: 20.18,
    y2: 14.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.36,
    y1: 18.36,
    x2: 3.82,
    y2: 18.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.45,
    y1: 14.73,
    x2: 3.82,
    y2: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,2h0a6.36,6.36,0,0,1,6.36,6.36v2.73a0,0,0,0,1,0,0H5.64a0,0,0,0,1,0,0V8.36A6.36,6.36,0,0,1,12,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.02de202d9f5a84be909ab5a8156347fd.svg";
export { ForwardRef as ReactComponent };